// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Banner_sliderContainer__9a0Sh","slide":"Banner_slide__MkOzP","image":"Banner_image__KXGTH"};